import { motion } from "framer-motion";

export const ApplicationsIntro = () => (
  <section data-testid="applications-intro-section" className="bg-baseLight px-6 pt-[30px] pb-[30px] lg:pt-0 sm:pb-[28px] lg:px-12 lg:pb-[40px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10"
      >
        <h2
          data-testid="applications-intro-headline"
          className="font-heading text-[26px] font-semibold leading-tight text-ink sm:text-[30px] lg:col-span-5 lg:text-[32px]"
        >
          Different operations, different energy priorities
        </h2>
        <p data-testid="applications-intro-text" className="text-[15px] leading-relaxed text-inkSoft lg:col-span-7 lg:pt-1">
          From continuous refrigeration and ventilation to seasonal processing loads and
          remote-site power, each application requires a different balance of renewable
          generation, short-duration battery response and long-duration hydrogen energy storage.
        </p>
      </motion.div>
      <div className="mt-8 border-t border-borderLight lg:mt-12" />
    </div>
  </section>
);
